module.exports = __webpack_public_path__ + "img/blog-details.72d3ce79.png";